import styled from "styled-components";
import { useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import CustomButton from "../../../helperComponents/CustomButton";
import MaterialInput from "../../../helperComponents/MaterialInput";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin-top: 100px;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 50vw;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  border-radius: 20px;
  background-color: var(--surface2);
  border: 1px solid var(--border);
`;

const Buttons = styled.div`
  width: 38vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function AddOrEditZone({}) {
  const { t } = useTranslation();
  const [itemID, setItemID] = useState(null);
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("ADD");

  useEffect(() => {
    let newItemID = getUrlQuery("itemID");
    setItemID(newItemID);

    if (newItemID) setPurpose("UPDATE");
  }, []);

  useEffect(() => {
    if (purpose == "UPDATE") {
      setLoading(true);
      if (itemID) {
        loadItemToBeEdited();
      }
    }
  }, [itemID]);

  let titleLine1 = "Ajouter";
  let titleLine2 = "Une zone";

  if (purpose == "UPDATE") {
    titleLine1 = "Zone";
    titleLine2 = "d'édition";
  }

  let coreContent = <LoadingSection />;

  if (!loading) {
    coreContent = (
      <Container>
        <Inputs>
          <InputItems>
            <MaterialInput
              label={"Nom"}
              value={item.name}
              onChange={updateField("name")}
            />
            <MaterialInput
              rows={2}
              multiline={true}
              label={"Description"}
              value={item.description}
              onChange={updateField("description")}
            />
          </InputItems>
          <br />
          <Buttons>
            <CustomButton style={{ padding: "15px 40px" }} onClick={save}>
              {purpose == "UPDATE" ? "Zone d'édition" : "Ajouter une zone"}
            </CustomButton>
          </Buttons>
        </Inputs>
      </Container>
    );
  }

  return (
    <PermissionGuard
      permissionName={"zonePermissions"}
      action={purpose == "ADD" ? "CREATE" : "UPDATE"}
    >
      <LoggedInBoilerplate
        showBackButton={true}
        titleLine1={titleLine1}
        titleLine2={titleLine2}
      >
        {coreContent}
      </LoggedInBoilerplate>
    </PermissionGuard>
  );

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      let newItem = { ...item };
      if (dontUseEventValue) {
        newItem[fieldName] = e;
      } else {
        newItem[fieldName] = e.target.value;
      }

      setItem(newItem);
    };
  }

  function save() {
    if (purpose == "UPDATE") editItem();
    if (purpose == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/zone/?itemID=${itemID}`);

    setItem(data);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/zone", {
        name: item.name,
        description: item.description,
      });

      goTo(`/zones`)();
      // goTo(`/zone/${res._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/zone", {
        itemID,
        changes: {
          name: item.name,
          description: item.description,
        },
      });

      window.popupAlert(t("done"));
      // goTo(`/zone/${itemID}`)();
      goTo(`/zones`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
